import Modal from '@/components/Modal';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { IS_WECOM } from '@/utils/env';
import { Brand_Logo } from '@/utils/uiHelper';
import {
  CalendarOutlined,
  DownOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MoonOutlined,
  SunOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, ConfigProvider, Dropdown, MenuProps } from 'antd';
import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useThemeOptions } from './ThemeSwitch';
import { PerspectiveSwitcher } from './components/PerspectiveSwitcher';
import { useHeaderStyles } from './header.style';

export const AppHeader = ({
  collapsed,
  toggle,
  onLogout,
}: {
  collapsed: boolean;
  toggle: () => void;
  onLogout: () => void;
}) => {
  const [baseInfo] = useContext(BaseInfoContext);
  const { styles: headerStyle, cx } = useHeaderStyles();
  const { menu: themeMenu, appearance } = useThemeOptions();

  const profileMenu = useMemo(() => {
    var items: MenuProps['items'] = [
      {
        label: <Link to="/profile/hr">考勤与绩效</Link>,
        key: 'hr',
        icon: <CalendarOutlined />,
      },
      {
        label: <Link to="/profile/account">我的账号</Link>,
        key: 'account',
        icon: <UserOutlined />,
      },
      { type: 'divider' },
      {
        label: <span>主题模式</span>,
        key: 'theme',
        icon: appearance === 'dark' ? <MoonOutlined /> : <SunOutlined />,
        children: themeMenu.items,
      },
    ];

    if (!IS_WECOM) {
      items.push({
        type: 'divider',
      });

      items.push({
        label: <span>退出</span>,
        key: 'logout',
        icon: <LogoutOutlined />,
        onClick: () => {
          Modal.confirm({
            title: '确认退出登录吗？',
            onOk: () => {
              onLogout();
            },
          });
        },
      });
    }

    return {
      items,
    };
  }, [onLogout, themeMenu, appearance]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Dropdown: {
            paddingBlock: '10px',
          },
        },
      }}>
      <div className={`${headerStyle.container}`}>
        <div className={headerStyle.left}>
          <div className={cx(headerStyle.logo, { collapsed })}>
            <Link to="/" className={headerStyle.logoInner}>
              <img src={Brand_Logo} draggable={false} alt={'logo'} />
              <span>veeyung</span>
            </Link>
          </div>

          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: headerStyle.menuToggleTrigger,
            onClick: toggle,
          })}
        </div>
        <div className={headerStyle.login}>
          <PerspectiveSwitcher />

          <Dropdown arrow placement="bottomRight" trigger={['click']} menu={profileMenu}>
            <Button
              style={{
                backgroundColor: 'transparent',
                color: '#fff',
                borderColor: 'transparent',
              }}>
              {baseInfo.nickname}
              <DownOutlined style={{ fontSize: 10 }} />
            </Button>
          </Dropdown>
        </div>
      </div>
    </ConfigProvider>
  );
};
